module.exports = require(31).PassThrough
